import React, {useEffect} from 'react';
import './App.css';

import '@fontsource/rethink-sans/400.css';
import '@fontsource/rethink-sans/500.css';
import '@fontsource/rethink-sans/600.css';
import '@fontsource/rethink-sans/700.css';
import '@fontsource/rethink-sans/800.css';
import {Grid2} from "@mui/material";
import Pagina from "../src/Pagina/Pagina";
import {iniciarAnaliticas} from "./Servicios/Analiticas/iniciarAnaliticas";


function App() {

    useEffect(() => {
        iniciarAnaliticas()
    }, []);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Pagina/>

        </Grid2>
    );
}

export default App;
